export function isSizeLarge(size) {
  return size === 'lg';
}
export function isSizeSmall(size) {
  return size === 'sm';
}